<script>
	import {
		Listbox,
		ListboxButton,
		ListboxOptions,
		ListboxOption,
	} from "@rgossiaux/svelte-headlessui";

	export let typeface;

	const fontlist = [
		{id: 1, slug: 'sans', label: 'Sans Serif'},
		{id: 2, slug: 'geom', label: 'Geometric'},
		{id: 3, slug: 'serif', label: 'Serif'},
		{id: 4, slug: 'mono', label: 'Monospaced'},
		{id: 5, slug: 'cond', label: 'Condensed'},
		{id: 6, slug: 'mode', label: 'Modern'},
		{id: 7, slug: 'disp', label: 'Display'},
		{id: 8, slug: 'brut', label: 'Brutalist'},
		{id: 9, slug: 'slab', label: 'Slab Serif'}
	];

	typeface = fontlist[0];

</script>

<!--
<ul class="fonts" role="list">
	{#each fontlist as f}
		<li class="font-item">
		    <input
		      type="radio" bind:group={typeface} name="typeface"
		      value="{f.slug}" id="{f.slug}"
		    >
		    <label for="{f.slug}">
		    	<img src="{`img/${f.slug}.svg`}" alt="{f.label}">
		    	<span>{f.label}</span>
		    </label>
	    </li>
	{/each}
</ul>
-->

<Listbox bind:value={typeface} class="listbox">
	<ListboxButton>
		<span class={typeface.slug}>{typeface.label}</span>
	</ListboxButton>

	<div class="lb-options">
		<ListboxOptions>
			{#each fontlist as font (font.id)}
				<ListboxOption
					value={font}
					class={({ active }) => (active ? "active" : "")}
					let:selected
				>
					<div class="{font.slug} {(selected ? "selected" : "")}">
						{#if selected}
							<img src="./img/check.svg" alt="Selected" />
						{/if}
						{font.label}
					</div>
				</ListboxOption>
			{/each}
		</ListboxOptions>
	</div>
</Listbox>

<style lang="scss">

</style>
